import { colors } from '../../../utilities/colors'

const ORDER_STATUS_COLOR = {
  new: '#4A90D9',
  ordered: '#4A90D9',
  processing: colors.yellow,
  complete: colors.green,
  hold: colors.fpxRed,
}

export const orderStatusColor = (status) => ORDER_STATUS_COLOR[status] || colors.grey300
